import React from "react";
import { Link } from "react-router-dom";

import "./index.css";

import {
  getCoreRowModel,
  useReactTable,
  flexRender,
  getSortedRowModel,
} from "@tanstack/react-table";
function propertyLink(id) {
  let prop_link = "/dashboard/property/" + id;
  return prop_link;
}
function formatToCrowns(number) {
  if (number != null) {
    return number.toLocaleString().replace(/,/g, " ") + " kr";
  } else return "";
}

export default function Interest({ data }) {
  const defaultColumns = [
    {
      header: "Ränta",
      columns: [
        {
          accessorKey: "street",
          cell: (info) => <Link to={propertyLink(info.row.original.id)}>{info.getValue()}</Link>,
          header: () => <span>Adress</span>,
        },
        {
          accessorKey: "interestPerYear",
          header: () => <span>Räntekostnad/år</span>,
          cell: (info) => formatToCrowns(info.getValue()),
        },
        {
          accessorKey: "interestPerMonth",
          header: () => <span>Räntekostnad/mån</span>,
          cell: (info) => formatToCrowns(info.getValue()),
        },
        {
          accessorKey: "effectiveInterestRate",
          header: () => <span>Ränteavdrag i %</span>,
          cell: (info) => info.getValue() + "%",
        },
        {
          accessorKey: "interestDeductionPerMonth",
          id: "deduction",
          header: () => <span>Ränteavdrag/mån</span>,
          cell: (info) => formatToCrowns(info.getValue()),
        },
        {
          accessorKey: "totInterest",
          header: () => <span>Tot räntekostnad/mån</span>,
          cell: (info) => formatToCrowns(info.getValue()),
        },
      ],
    },
  ];
  // const [data, setData] = React.useState(() => [...defaultData]);
  // const [data] = React.useState(() => [...defaultData]);
  const [columns] = [defaultColumns]; // TODO here i am hacking! Usestate correctly?

  const [sorting, setSorting] = React.useState();

  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  return (
    <div className="p-2">
      <p>
        Ränteavdraget är 30% upp till 100 000kr per person. Efter det är det 21% på räntekostnader
        över 100 000kr per person. Det betyder att om räntekostnaderna är högre än 100 000kr så är
        det fördelaktigt att vara fler personer.
      </p>
      <table>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                return (
                  <th key={header.id} colSpan={header.colSpan}>
                    {header.isPlaceholder ? null : (
                      <div
                        {...{
                          className: header.column.getCanSort() ? "cursor-pointer select-none" : "",
                          onClick: header.column.getToggleSortingHandler(),
                        }}
                      >
                        {flexRender(header.column.columnDef.header, header.getContext())}
                        {{
                          asc: " 🔼",
                          desc: " 🔽",
                        }[header.column.getIsSorted()] ?? null}
                      </div>
                    )}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => {
            return (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => {
                  return (
                    <td key={cell.id}>
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
